import React, { useState, useRef, useEffect } from 'react';
import ChatBubble from '../Components/Chatbubble';
import MessageInput from '../Components/MessageInput';
import kumarAvatar from '../Assets/kumar-avatar.png';
import userAvatar from '../Assets/User-avatar.png'; // ✅ Import user avatar
import TypingDots from '../Components/TypingDots';
import { callOpenAI } from '../utils/openaiService';

const SoftSkills = () => {
  const chatContainerRef = useRef(null); // ✅ Ref for scroll
  const [chatMessages, setChatMessages] = useState([
    {
      sender: 'ai',
      avatar: kumarAvatar,
      name: 'Kumar',
      message: `Let's talk soft skills da! 🗣️

These are the hidden superpowers that make you stand out — communication, teamwork, leadership, empathy, and more.

I’ll help you level them up step-by-step. Ready to strengthen your core skills? 💪`,
      timestamp: new Date().toLocaleString(),
    },
  ]);
  const [isThinking, setIsThinking] = useState(false);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatMessages, isThinking]);

  const handleSend = async (text) => {
    if (!text.trim()) return;
    setIsThinking(true);

    const newUserMessage = {
      sender: 'user',
      avatar: userAvatar, // ✅ Add user avatar
      name: 'You',
      message: text,
      timestamp: new Date().toLocaleString(),
    };

    const updatedMessages = [...chatMessages, newUserMessage];
    setChatMessages(updatedMessages);

    const formattedMessages = updatedMessages.map((msg) => ({
      role: msg.sender === 'ai' ? 'assistant' : 'user',
      content: msg.message,
    }));

    const response = await callOpenAI({
      messages: formattedMessages,
      screenContext: 'softskills',
    });

    setChatMessages((prev) => [
      ...prev,
      {
        sender: 'ai',
        avatar: kumarAvatar,
        name: 'Kumar',
        message: response,
        timestamp: new Date().toLocaleString(),
      },
    ]);
    setIsThinking(false);
  };

  return (
    <div className="bg-white/80 backdrop-blur-md rounded-[30px] shadow-xl p-6 flex flex-col justify-between min-h-[75vh] w-full max-w-[950px] mx-auto">
      <div
        className="flex flex-col gap-6 overflow-y-auto flex-grow pr-2 custom-scroll max-h-[60vh]"
        ref={chatContainerRef} // ✅ Attach scroll ref
      >
        {chatMessages.map((msg, idx) => (
          <ChatBubble
            key={idx}
            sender={msg.sender}
            avatar={msg.avatar}
            name={msg.name}
            message={msg.message}
            timestamp={msg.timestamp}
          />
        ))}

        {isThinking && (
          <ChatBubble
            sender="ai"
            avatar={kumarAvatar}
            name="Kumar"
            message={<TypingDots />}
          />
        )}
      </div>

      <div className="mt-6">
        <MessageInput onSend={handleSend} />
      </div>
    </div>
  );
};

export default SoftSkills;
